import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[trim]', // Seletor da diretiva
  standalone: false,
})
export class TrimReactiveDirective {
  constructor(private el: ElementRef) { }

  @HostListener('blur', ['$event.target'])
  onBlur(target: HTMLInputElement) {
    const value = target.value.trim();
    target.value = value; // Atualiza o valor do campo com a versão trimada
    this.el.nativeElement.dispatchEvent(new Event('input')); // Dispara o evento de input para atualizar modelos no Angular, se necessário
  }
}